import { render, staticRenderFns } from "./ViewOrderReasonDialogsPartial.vue?vue&type=template&id=7070a354&"
import script from "./ViewOrderReasonDialogsPartial.vue?vue&type=script&lang=js&"
export * from "./ViewOrderReasonDialogsPartial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports